(() => {
  const EMAIL_PATTERN = /^[^@\s]+@[^@\s.]+\.[^@\s]+$/;
  const PHONE_PATTERN = /^(\+?373|0)\d{8}$/;
  const SENT_PARAM = 'consult_sent';
  const SUBMIT_RELEASE_DELAY = 15000;

  class ConsultField {
    constructor(input) {
      this.input = input;
      this.error = input.parentElement.querySelector('[data-consult-error]');
      this.rule = input.dataset.rule || 'required';
    }

    get valid() {
      const value = this.input.value.trim();
      if (!value) return false;
      if (this.rule === 'email') return EMAIL_PATTERN.test(value);
      if (this.rule === 'phone') return PHONE_PATTERN.test(value.replace(/[\s().-]/g, ''));
      return true;
    }

    showError(show) {
      const invalid = show && !this.valid;
      if (this.error) this.error.hidden = !invalid;
      this.input.setAttribute('aria-invalid', String(invalid));
    }

    reset() {
      this.input.value = '';
      this.showError(false);
    }
  }

  class SalutConsultCall extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-consult-dialog]');

      this.querySelector('[data-consult-trigger]')?.addEventListener('click', () => this.open());

      if (!this.dialog) return;

      this.labelledBy = this.dialog.getAttribute('aria-labelledby');
      this.view = this.dialog.querySelector('[data-consult-view]');
      this.sent = this.dialog.querySelector('[data-consult-sent]');
      this.form = this.dialog.querySelector('form');
      this.submit = this.dialog.querySelector('[data-consult-submit]');
      this.fields = Array.from(this.dialog.querySelectorAll('[data-consult-input]')).map(
        (input) => new ConsultField(input)
      );

      this.dialog.querySelector('[data-consult-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog.querySelector('[data-consult-continue]')?.addEventListener('click', () => this.dialog.close());

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      this.dialog.addEventListener('close', () => {
        this.releaseScroll();
        this.reset();
      });

      this.fields.forEach((field) => {
        field.input.addEventListener('blur', () => field.showError(true));
        field.input.addEventListener('input', () => {
          field.showError(false);
          this.refresh();
        });
      });

      this.form?.addEventListener('submit', (event) => this.onSubmit(event));

      this.refresh();
      this.restoreSent();
    }

    disconnectedCallback() {
      this.releaseScroll();
    }

    open() {
      if (!this.dialog) return;
      this.dialog.showModal();
      document.body.classList.add('overflow-hidden');
    }

    refresh() {
      if (this.submit) this.submit.disabled = !this.fields.every((field) => field.valid);
    }

    onSubmit(event) {
      const invalid = this.fields.filter((field) => !field.valid);
      invalid.forEach((field) => field.showError(true));

      if (invalid.length) {
        event.preventDefault();
        invalid[0].input.focus();
        return;
      }

      this.setBusy(true);
    }

    setBusy(busy) {
      if (!this.submit) return;

      clearTimeout(this.releaseTimer);
      this.submit.disabled = busy;
      this.submit.toggleAttribute('aria-busy', busy);

      if (busy) this.releaseTimer = setTimeout(() => this.setBusy(false), SUBMIT_RELEASE_DELAY);
    }

    restoreSent() {
      const params = new URLSearchParams(window.location.search);
      if (params.get(SENT_PARAM) !== '1') return;

      params.delete(SENT_PARAM);
      const query = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);

      this.open();
      this.showSent();
    }

    showSent() {
      this.view.hidden = true;
      this.sent.hidden = false;
      this.dialog.classList.add('is-sent');

      const title = this.sent.querySelector('.consult-dialog__sent-title');
      if (title) this.dialog.setAttribute('aria-labelledby', title.id);

      this.dialog.querySelector('[data-consult-continue]')?.focus();
    }

    reset() {
      if (!this.sent || this.sent.hidden) return;

      this.form?.reset();
      this.fields.forEach((field) => field.reset());
      this.setBusy(false);
      this.refresh();
      this.view.hidden = false;
      this.sent.hidden = true;
      this.dialog.classList.remove('is-sent');
      this.dialog.setAttribute('aria-labelledby', this.labelledBy);
    }

    releaseScroll() {
      if (document.querySelector('.consult-dialog[open]')) return;
      document.body.classList.remove('overflow-hidden');
    }
  }

  if (!customElements.get('salut-consult-call')) customElements.define('salut-consult-call', SalutConsultCall);
})();
